// extracted by mini-css-extract-plugin
export default {"form":"CancelarPedidoBmaFolha_form__g4cM2","areaBtn":"CancelarPedidoBmaFolha_areaBtn__XTHtK","btn":"CancelarPedidoBmaFolha_btn__I4Xtf"};